import React from 'react';
import {Header as HeaderStyle, Logo, Content, Clear, DsFlex} from './styled';
import Logotipo from '../../assets/svg/logo.svg';
import {Link, useLocation} from 'react-router-dom';

const HeaderAlternative: React.FC = () => {
    const location = useLocation();
    const menu = React.useRef<HTMLElement>(null)
    const urlWithHeader = ['/area-restrita/politica-de-cookies', '/area-restrita/contato'];

    React.useEffect(() => {
        window.addEventListener("scroll", () => {
            const lastKnownScrollPosition = window.scrollY;

            if(!menu.current) return;

            if(lastKnownScrollPosition > 200){
                menu.current.style.position = "fixed";
                menu.current.style.top = "0";
                menu.current.style.left = "0";
                menu.current.style.width = "100%";  
                menu.current.style.transition = "1s";                      
            }else{
                menu.current.style.position = "static";                
            }
        });
    }, []);

    return (
        <>
            {urlWithHeader.includes(location.pathname) &&
                <HeaderStyle ref={menu}>
                    <Content>
                        <DsFlex>
                            <Logo>
                                Sultan Veste a Casa, Área Restrita
                                <img src={Logotipo} title="Sultan Veste a Casa, Área Restrita"
                                    alt="Sultan Veste a Casa, Área Restrita"/>
                            </Logo>
                            <Link to={`${process.env.PUBLIC_URL}/`}>Voltar ao Site</Link>
                        </DsFlex>
                        <Clear/>
                    </Content>
                </HeaderStyle>
            }
        </>
    );
}

export default HeaderAlternative;